import type { LabeledOption, Nullable } from '@iheartjane/types';

import type { BloomFontFamily } from '@jane/business-admin/types';
import type { GoogleFontFamily } from '@jane/shared-ecomm/data-access';

export const toLabeledFontOption = (
  googleFont?: Nullable<GoogleFontFamily>
): Nullable<LabeledOption> =>
  googleFont
    ? {
        label: googleFont.family,
        value: googleFont.family,
      }
    : null;

export const toBloomFontFamily = (
  googleFont?: Nullable<GoogleFontFamily>
): BloomFontFamily | undefined => {
  if (!googleFont) {
    return undefined;
  }
  /** @see https://developers.google.com/fonts/docs/getting_started#specifying_font_families_and_styles_in_a_stylesheet_url */
  const styleSheetUrl = `https://fonts.googleapis.com/css?${new URLSearchParams(
    {
      family: `${googleFont.family}:r,b`,
      display: 'swap',
    }
  ).toString()}`;

  return { font_family: googleFont.family, url: styleSheetUrl };
};
